<ng-container *ngIf='!accessDenied'>
    <div *ngIf="!loader" class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">TENANT CONFIGURATION</h5>
                <div style="flex-grow: 1;"></div>
                <button id="edit" (click)="editTenantConfig($event)" class="btn btn-primary float-right mr-3"> Edit
                </button>
                <!-- <button id="add" (click)="onBack()" class="btn btn-primary float-right mr-3"> Back </button> -->
            </div>

        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-md-2 light-bg grid-details"
                 *ngFor="let config of tenantConfigList; let i = index">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{config.displayName}}">
                    <h5 class="mb-lg-0 text-truncate">
                        <b> {{config.displayName}} </b>
                    </h5>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h5 class="mb-lg-0 text-truncate">
                        <b>:</b>
                    </h5>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{config.value}}">
                    <ng-container *ngIf="getConfigType(config)==4?true : false">
                        <h5 class="mb-lg-0 text-truncate">
                            <input type="color" [value]="config.value" [attr.id]="i"
                                   style="width: 30px; height: 30px; padding: 0 !important;" disabled/>
                            <input maxlength="7" type="text" [value]="config.value != undefined ? config.value : '' "
                                   [attr.id]="i" readonly/>
                        </h5>
                    </ng-container>
                    <ng-container *ngIf="getConfigType(config)!=4?true : false">
                        <h5 class="mb-lg-0 text-truncate"> {{config.value}} </h5>
                    </ng-container>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <label>
                    <h5 class="mb-lg-0 text-truncate">
                        Custom Scales
                    </h5>
                </label>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Scale">
                        <h5 class="mb-lg-0 medium text-truncate"> Scale </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Value">
                        <h5 class="mb-lg-0 medium text=text-truncate"> Code </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Colour">
                        <h5 class="mb-lg-0 medium text-truncate"> Value </h5>
                    </div>
                </div>
                <div class="w-100 float-left p-md-2 light-bg grid-details"
                     *ngFor="let scale of customScaleList; let i = index">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{scale.displayName}}">
                        <h5 class="mb-lg-0 text-truncate">
                            {{scale.displayName}}
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{scale.value.code}}">
                        <h5 class="mb-lg-0 text-truncate">
                            {{scale.value.code}}
                            <!-- <input type="color" [value]="scale.value.code" [attr.id]="i" style="width: 30px; height: 30px; padding: 0 !important;" disabled/> -->
                            <!-- <input maxlength="7" type="text" [value]="scale.value.code != undefined ? scale.value.code : '' " [attr.id]="i" readonly/> -->
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{scale.value.value}}">
                        <h5 class="mb-lg-0 text-truncate">
                            {{scale.value.value}}
                            <!-- <input type="color" [value]="scale.value.value" [attr.id]="i" style="width: 30px; height: 30px; padding: 0 !important;" disabled/> -->
                            <!-- <input maxlength="7" type="text" [value]="scale.value.value != undefined ? scale.value.value : '' " [attr.id]="i" readonly/> -->
                        </h5>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <label>
                    <h5 class="mb-lg-0 text-truncate">
                        Indicators
                    </h5>
                </label>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Scale">
                        <h5 class="mb-lg-0 medium text-truncate"> Scale </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Value">
                        <h5 class="mb-lg-0 medium text=text-truncate"> Value </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Colour">
                        <h5 class="mb-lg-0 medium text-truncate"> Colour </h5>
                    </div>
                </div>
                <div class="w-100 float-left p-md-2 light-bg grid-details"
                     *ngFor="let indicator of tntConfData.measureStatusIndicatorData; let i = index">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{indicator.name}}">
                        <h5 class="mb-lg-0 text-truncate">
                            {{indicator.name}}
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{indicator.value}}">
                        <h5 class="mb-lg-0 text-truncate">
                            {{indicator.value}}
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{indicator.code}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input type="color" [value]="indicator.code" [attr.id]="i"
                                   style="width: 30px; height: 30px; padding: 0 !important;" disabled/>
                            <input maxlength="7" type="text"
                                   [value]="indicator.code != undefined ? indicator.code : '' " [attr.id]="i" readonly/>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <label>
                    <h5 class="mb-lg-0 text-truncate">
                        Page Config
                    </h5>
                </label>
                <div class="w-100 float-left p-md-2 light-bg grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Page Snapshot Expiry">
                        <h5 class="mb-lg-0 medium text-truncate"> Page Snapshot Expiry</h5>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                        <h5 class="mb-lg-0 text-truncate">
                            <b>:</b>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"
                         ngbTooltip="{{dashboardExpiry ? dashboardExpiry.value : ''}}">
                        <h5 class="mb-lg-0 text-truncate">
                            {{dashboardExpiry ? dashboardExpiry.value : 30}} Days
                        </h5>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <label>
                    <h5 class="mb-lg-0 text-truncate">
                        Color Palette
                    </h5>
                </label>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="startcolor">
                        <h5 class="mb-lg-0 medium text-truncate"> Start Colour </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="endcolour">
                        <h5 class="mb-lg-0 medium text-truncate"> End Colour </h5>
                    </div>
                </div>
                <div class="w-100 float-left p-md-2 light-bg grid-details"
                     *ngFor="let colorpalette of colorPaletevalue; let i = index">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"
                         ngbTooltip="{{colorpalette.startcolor}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input type="color" [value]="colorpalette.startcolor" [attr.id]="i"
                                   style="width: 30px; height: 30px; padding: 0 !important;" disabled/>
                            <input maxlength="7" type="text"
                                   [value]="colorpalette.startcolor != undefined ? colorpalette.startcolor : '' "
                                   [attr.id]="i" readonly/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{colorpalette.endcolor}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input type="color" [value]="colorpalette.endcolor" [attr.id]="i"
                                   style="width: 30px; height: 30px; padding: 0 !important;" disabled/>
                            <input maxlength="7" type="text"
                                   [value]="colorpalette.endcolor != undefined ? colorpalette.endcolor : '' "
                                   [attr.id]="i"
                                   readonly/>
                        </h5>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="tntConfData == undefined">
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>
        </div>
        <div *ngIf='isEdit' class="main-table table-custom">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0" *ngIf="isEdit">Edit Tenant Configuration</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
                <button class="btn btn-secondary" (click)="onBack()">
                    <i class="fa fa-arrow-left mr-sm-2"></i> Back
                </button>
            </div>
            <div class="w-100 float-left p-md-2 light-bg grid-details"
                 *ngFor="let config of tenantConfigList; let i = index">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{config.displayName}}">
                    <h5 class="mb-lg-0 text-truncate">
                        <b> {{config.displayName}} </b>
                    </h5>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h5 class="mb-lg-0 text-truncate">
                        <b>:</b>
                    </h5>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left" ngbTooltip="{{config.value}}">
                    <h5 class="mb-lg-0 text-truncate" *ngIf="getConfigType(config)==1?true : false">
                        <select class="form-control" id="weekStartDay" (change)="changeWeekStartDay($event, config)">
                            <option *ngFor='let day of weekDayList; let j = index' [attr.value]='day'
                                    [attr.selected]="config.value.toLowerCase() == day.toLowerCase() ? true : null">
                                <h5 class="mb-lg-0 text-truncate">{{getWeekName(day)}}</h5>
                            </option>
                        </select>
                    </h5>
                    <h5 class="mb-lg-0 text-truncate" *ngIf="getConfigType(config)==2?true : false">
                        <input type="number" min="1" max="31" [ngModel]="config.value" id="monthStartDay"
                               (blur)="validateDay($event, i)" (keyup)="validateDay($event, i)" class="w-100 p-sm b-a"
                               placeholder="Value"/>
                        <p class="mb-lg-0" *ngIf="xErrorMsg !=''? true : false">{{xErrorMsg}}</p>
                    </h5>
                    <h5 class="mb-lg-0 text-truncate" *ngIf="getConfigType(config)==6?true : false">
                        <input type="number" [ngModel]="config.value" id="fontsize" (blur)="validateNumber($event, i)"
                               (keyup)="validateNumber($event, i)" class="w-100 p-sm b-a" placeholder="Value"/>
                        <p class="mb-lg-0" *ngIf="xErrorMsg !=''? true : false">{{xErrorMsg}}</p>
                    </h5>
                    <h5 class="mb-lg-0 text-truncate" *ngIf="getConfigType(config)==5?true : false">
                        <input type="number" min="1" max="12" [ngModel]="config.value" id="yearStartMonth"
                               (blur)="validateMonth($event, i)" (keyup)="validateMonth($event, i)"
                               class="w-100 p-sm b-a"
                               placeholder="Value"/>
                        <p class="mb-lg-0" *ngIf="xErrorMsg1 !=''? true : false">{{xErrorMsg1}}</p>
                    </h5>
                    <h5 class="mb-lg-0 text-truncate" *ngIf="getConfigType(config)==3?true : false">
                        <input type="text" [(ngModel)]="config.value" class="w-100 p-sm b-a" placeholder="Value"/>
                    </h5>
                    <h5 class="mb-lg-0 text-truncate" *ngIf="getConfigType(config)==4?true : false">
                        <input type="color" [(ngModel)]="config.value" [attr.id]="i"
                               style="width: 30px; height: 30px; padding: 0 !important;">
                        <input maxlength="7" type="text" [(ngModel)]="config.value" [attr.id]="i"/>
                    </h5>
                </div>
            </div>

            <div class="w-100 float-left mt-3">
                <div class="w-100 float-left p-md-2 grid-details">
                    <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                        <label>
                            <h5 class="mb-lg-0 text-truncate">
                                Custom Scales
                            </h5>
                        </label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <button id="add" (click)="addScales()" class="btn btn-primary float-right mr-3"> Add Scales
                        </button>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Scale">
                        <h5 class="mb-lg-0 medium text-truncate"> Scale </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Value">
                        <h5 class="mb-lg-0 medium text-truncate"> Code </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Colour">
                        <h5 class="mb-lg-0 medium text-truncate"> Value </h5>
                    </div>
                </div>
                <div class="w-100 float-left p-md-2 light-bg grid-details"
                     *ngFor="let scale of customScaleList; let i = index">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{scale.displayName}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input maxlength="200" type="text" placeholder="scale" [(ngModel)]="scale.displayName"
                                   class="w-100 p-sm b-a"/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{scale.value.code}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input maxlength="200" type="text" placeholder="code" [(ngModel)]="scale.value.code"
                                   class="w-100 p-sm b-a"/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{scale.value.value}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input maxlength="200" type="text" placeholder="code" [(ngModel)]="scale.value.value"
                                   class="w-100 p-sm b-a"/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center">
                        <h5 class="mb-lg-0 text-truncate">
                            <i class="fa fa-trash mr-2" id="delete" [attr.id]="i" (click)="onScaleDelete(i)"> Delete
                            </i>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <div class="w-100 float-left p-md-2 grid-details">
                    <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                        <label>
                            <h5 class="mb-lg-0 text-truncate">
                                Indicators
                            </h5>
                        </label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <button id="add" (click)="addIndicators()" class="btn btn-primary float-right mr-3"> Add
                            Indicators
                        </button>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Scale">
                        <h5 class="mb-lg-0 medium text-truncate"> Scale </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Value">
                        <h5 class="mb-lg-0 medium text-truncate"> Value </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Colour">
                        <h5 class="mb-lg-0 medium text-truncate"> Colour </h5>
                    </div>
                </div>
                <div class="w-100 float-left p-md-2 light-bg grid-details"
                     *ngFor="let indicator of tntConfData.measureStatusIndicatorData; let i = index">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{indicator.name}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input maxlength="200" type="text" maxlength="250" placeholder="scale"
                                   [(ngModel)]="indicator.name" class="w-100 p-sm b-a"/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{indicator.value}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input maxlength="200" type="number" placeholder="value" [(ngModel)]="indicator.value"
                                   class="w-100 p-sm b-a"/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{indicator.code}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input type="color" [value]="indicator.code" [attr.id]="i" [(ngModel)]="indicator.code"
                                   style="width: 30px; height: 30px; padding: 0 !important;">
                            <input maxlength="7" class="w-100 p-sm b-a" type="text" [(ngModel)]="indicator.code"
                                   [value]="indicator.code" [attr.id]="i"/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center">
                        <h5 class="mb-lg-0 text-truncate">
                            <i class="fa fa-trash mr-2" id="delete" [attr.id]="i" (click)="onIndicatorDelete(i)">
                                Delete </i>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <label>
                    <h5 class="mb-lg-0 text-truncate">
                        Page Config
                    </h5>
                </label>
                <div class="w-100 float-left p-md-2 light-bg grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Page Snapshot Expiry">
                        <h5 class="mb-lg-0 medium text-truncate"> Page Snapshot Expiry </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                        <h5 class="mb-lg-0 text-truncate">
                            <input (blur)="setExpiry($event)" (keypress)="validateDuration($event)"
                                   [value]="getValueFor()" autocomplete="off" class="form-control hideArrow"
                                   id="expiryDay" max="99" min="1" placeholder=" " size="100" type="number">
                        </h5>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                        <h5 class="mb-lg-0 text-truncate">
                            <b>Days</b>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <div class="w-100 float-left p-md-2 grid-details">
                    <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                        <label>
                            <h5 class="mb-lg-0 text-truncate">
                                Colour Palette
                            </h5>
                        </label>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <button id="add" (click)="addColorPalette()" class="btn btn-primary float-right mr-3"> Add
                            Colour Palette
                        </button>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="startcolor">
                        <h5 class="mb-lg-0 medium text-truncate"> Start Colour </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="endcolor">
                        <h5 class="mb-lg-0 medium text-truncate"> End Colour </h5>
                    </div>
                </div>
                <div class="w-100 float-left p-md-2 light-bg grid-details"
                     *ngFor="let colorpalette of colorPaletevalue; let i = index">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"
                         ngbTooltip="{{colorpalette.startcolor}}">
                        <h6 class="mb-lg-0 text-truncate">
                            <input type="color" [value]="colorpalette.startcolor" [attr.id]="i"
                                   [(ngModel)]="colorpalette.startcolor"
                                   style="width: 30px; height: 30px; padding: 0 !important;">

                            <input maxlength="7" class="w-100 p-sm b-a" type="text"
                                   [(ngModel)]="colorpalette.startcolor" [value]="colorpalette.startcolor"
                                   [attr.id]="i"/>
                        </h6>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{colorpalette.endcolor}}">
                        <h5 class="mb-lg-0 text-truncate">
                            <input type="color" [value]="colorpalette.endcolor" [attr.id]="i"
                                   [(ngModel)]="colorpalette.endcolor"
                                   style="width: 30px; height: 30px; padding: 0 !important;">
                            <input maxlength="7" class="w-100 p-sm b-a" type="text" [(ngModel)]="colorpalette.endcolor"
                                   [value]="colorpalette.endcolor" [attr.id]="i"/>
                        </h5>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center">
                        <h5 class="mb-lg-0 text-truncate">
                            <i class="fa fa-trash mr-2" id="delete" [attr.id]="i" (click)="onColorPaletteDelete(i)">
                                Delete </i>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3">
                <div class="w-100 float-left p-md-2 grid-details">
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <button id="save" (click)="onSave($event)" class="btn btn-primary float-right mr-3"> Save
                            Changes
                        </button>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <button id="reset" (click)="onResetDefaults($event)" class="btn btn-primary float-right mr-3">
                            Reset Defaults
                        </button>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="tntConfData == 0">
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>
        </div>
        <div class="w-100 float-left mt-3">
            <label>
                <h5 class="mb-lg-0 text-truncate">
                    Cache Management
                </h5>
            </label>
            <div class="w-100 float-none p-md-2 light-bg text-center">
                <button class="btn btn-primary center-block" (click)="onSyncCube()">
                    Sync Cube Meta Cache
                </button>
            </div>
            <div class="w-100 float-none p-md-2 light-bg text-center">
                <button class="btn btn-primary center-block" (click)="onSyncData()">
                    Sync Data Version Cache
                </button>
            </div>
            <div class="w-100 float-none p-md-2 light-bg text-center">
                <button class="btn btn-primary center-block" (click)="onFlushDash()">
                    Flush Dashboard Cache
                </button>
            </div>
            <div class="w-100 float-none p-md-2 light-bg text-center">
                <button class="btn btn-primary center-block" (click)="onSyncDash()">
                    Sync Dashboard Cache
                </button>
            </div>
            <div class="w-100 float-none p-md-2 light-bg text-center">
                <button class="btn btn-primary center-block" (click)="reBuildDashboardSnaphot()">
                    Rebuild Dashboard Snapshots
                </button>
            </div>
        </div>
    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/tenantConfiguration.component.html